jQuery(document).ready(function () {
  jQuery(document).on("click", ".sub-menu-main span.holderss", function (e) {
    // e.preventDefault();
    console.log("tt");

    console.log(jQuery(this).parent(".sub-menu-main").hasClass("active-menu"));
    if (jQuery(this).parent(".sub-menu-main").hasClass("active-menu")) {
      jQuery(this).parent(".sub-menu-main").removeClass("active-menu");
    } else {
      jQuery(this).parent(".sub-menu-main").addClass("active-menu");
    }
  });
  jQuery(".btn-atc.atc-popup.nt_btn_2d").addClass("active");
  jQuery(".btn-atc.atc-popup.nt_btn_2d .circle_radio").addClass("radio_color");
  jQuery(".rc_block.rc_block__type.rc_block__type__onetime").prepend(
    '<span class="circle_radio radio_color"></span>'
  );
  jQuery(".rc_block.rc_block__type.rc_block__type__autodeliver").prepend(
    '<span class="circle_radio"></span>'
  );
  jQuery(".btn-atc.atc-popup.nt_btn_2d").click(function () {
    jQuery(".btn-atc.atc-popup.nt_btn_2d").addClass("active");
    jQuery(".btn-atc.atc-popup.nt_btn_2d .circle_radio").addClass(
      "radio_color"
    );
    jQuery(".subcribe_product").removeClass("active");
    jQuery(".subcribe_product .circle_radio").removeClass("radio_color");
    jQuery(".btn-atc.atc-popup.nt_btn_2d .single_variation_wrap").css(
      "display",
      "flex"
    );
    jQuery("button#shopify_add_to_cart span.current-price").text(
      jQuery(
        ".yotpo-selling-plans .yotpo-selected .yotpo-tile-option-price"
      ).text()
    );
    // if(jQuery('.yotpo-selling-plans .yotpo-selected').attr('data-seling-plan-group-id') != 'buy-once'){
    // jQuery('button#shopify_add_to_cart span.bt__text').text('Subscription');
    // }
    // else{
    //   jQuery('button#shopify_add_to_cart span.bt__text').text('Add to cart');
    // }
  });
  jQuery(".subcribe_product").click(function () {
    jQuery(".btn-atc.atc-popup.nt_btn_2d .single_variation_wrap").css(
      "display",
      "none"
    );
    jQuery(".subcribe_product").addClass("active");
    jQuery(".btn-atc.atc-popup.nt_btn_2d .circle_radio").removeClass(
      "radio_color"
    );
    jQuery(".subcribe_product .circle_radio").addClass("radio_color");
    jQuery(".btn-atc.atc-popup.nt_btn_2d, .gray_form.s2").removeClass("active");
  });
  jQuery(".product_question_item_title").on("click", function (e) {
    if (jQuery(this).parent().hasClass("active")) {
      jQuery(".product_question_item").removeClass("active");
      jQuery(".product_question_item_title").next().slideUp(100);
    } else {
      jQuery(".product_question_item").removeClass("active");
      jQuery(".product_question_item_title")
        .parent(".product_question_item:not(.active)")
        .find(".product_question_item_content")
        .slideUp();
      jQuery(this).next().slideDown(100);
      jQuery(this).parent(".product_question_item").toggleClass("active");
    }
  });
  jQuery(".sp-tabs-wrapper > h2,.panel.entry-content > h2, .tab_html > h2").on(
    "click",
    function (e) {
      jQuery(this).toggleClass("active");
      jQuery(this).next().toggleClass("active");
    }
  );
  jQuery(document).on("click", ".product_question_title", function (e) {
    if (jQuery(window).width() <= 767) {
      jQuery(this).toggleClass("active");
      jQuery(this).next().toggleClass("active");
    }
  });
  jQuery(document).mouseup(function (e) {
    if (jQuery(".autocomplete-suggestions li").length) {
      var container_pop_table = jQuery(".search_extended");
      if (
        !container_pop_table.is(e.target) &&
        container_pop_table.has(e.target).length === 0
      ) {
        jQuery(".autocomplete-suggestions li").remove();
      }
    }
  });
  jQuery(".sp-tabs > li > .scroll_to").click(function () {
    var to_div = jQuery(this).attr("data-scroll");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(to_div).offset().top - 200,
      },
      1000
    );
  });

  jQuery(
    ".subrice_label.has_discount input, .subrice_label.has_discount"
  ).click(function () {
    jQuery('.subrice_label.normal input[type="radio"]').attr("checked", false);
    jQuery(".subrice_label.normal").removeClass("active");
    jQuery(".gray_form").removeClass("active");
    jQuery(".subcribe_product").addClass("active");
    jQuery(".subrice_label.has_discount").addClass("active");
    var inputchecked = jQuery(this)
      .parents(".subcribe_product")
      .find(".single_variation_delivery_choose option:selected")
      .attr("data-value");
    jQuery(".line-item-property__field input").prop("checked", false);
    jQuery(".line-item-property__field")
      .find('input[data-value="' + inputchecked + '"]')
      .prop("checked", true);
  });

  jQuery(".single_variation_delivery_choose").change(function () {
    var inputchange = jQuery(this).find("option:selected").attr("data-value");
    jQuery(".line-item-property__field input").prop("checked", "false");
    jQuery(".line-item-property__field")
      .find('input[data-value="' + inputchange + '"]')
      .prop("checked", "true");
  });
  jQuery(".subrice_label.normal input, .subrice_label.normal").click(
    function () {
      jQuery('.subrice_label.has_discount input[type="radio"]').attr(
        "checked",
        false
      );
      jQuery(".subrice_label.normal").addClass("active");
      jQuery(".gray_form").addClass("active");
      jQuery(".subrice_label.has_discount").removeClass("active");
      jQuery(".subcribe_product").removeClass("active");
      jQuery(".line-item-property__field input").prop("checked", false);
    }
  );

  var defaultcomtentitem = jQuery(
    '.cart_variation_delivery_choose li[data-value="1"]'
  ).html();
  jQuery(".subscribe_save").click(function () {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(".cart-drawer__item-property").text("");
    } else {
      jQuery(this).addClass("active");
      jQuery(".cart-drawer__item-property").text(defaultcomtentitem);
    }
  });
  jQuery(".cart-drawer__item-property").click(function () {
    if (jQuery(this).hasClass("active")) {
      jQuery(this)
        .parent(".cart-drawer__item-properties")
        .next(".cart_variation_delivery_choose")
        .removeClass("active");
    } else {
      jQuery(this)
        .parent(".cart-drawer__item-properties")
        .next(".cart_variation_delivery_choose")
        .addClass("active");
    }
  });
  jQuery(".cart_variation_delivery_choose li").click(function () {
    var contentitem = jQuery(this).html();
    jQuery(".cart-drawer__item-property").text(contentitem);
    jQuery(this)
      .parent(".cart_variation_delivery_choose")
      .removeClass("active");
    jQuery(".cart-drawer__item-property").removeClass("active");
  });
  if (jQuery(window).width() < 768) {
    jQuery(
      "#shopify-section-product-page-description .tab-panels .sp-tabs-wrapper:first-child h2"
    ).addClass("active");
    jQuery(
      "#shopify-section-product-page-description .tab-panels .sp-tabs-wrapper:first-child h2 + .entry-content"
    ).addClass("active");
  }
  jQuery(window).resize(function () {
    if (jQuery(window).width() < 768) {
      jQuery(
        "#shopify-section-product-page-description .tab-panels .sp-tabs-wrapper:first-child h2"
      ).addClass("active");
      jQuery(
        "#shopify-section-product-page-description .tab-panels .sp-tabs-wrapper:first-child h2 + .entry-content"
      ).addClass("active");
    }

    if (jQuery(window).width() < 768) {
      if (jQuery(".the4_custom_faq_box #section-faq").length > 0) {
        var faq_mobile = jQuery(".the4_custom_faq_box #section-faq").clone();
        jQuery(".product_faq_custom_tabmobile").html(faq_mobile);
        jQuery(".the4_custom_faq_box #section-faq").remove();
      }
    } else {
      if (jQuery(".product_faq_custom_tabmobile #section-faq").length > 0) {
        var faq_desktop = jQuery(
          ".product_faq_custom_tabmobile #section-faq"
        ).clone();
        jQuery(".the4_custom_faq_box").html(faq_desktop);
        jQuery(".product_faq_custom_tabmobile #section-faq").remove();
      }
    }
  });
  // Home review section slider

  jQuery(".review-block").slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /*march 21 2023*/
  /*slider for home page menu*/
  $(document).ready(function () {
    var found = setInterval(function () {
      if ($(".slider-images").length) {
        clearInterval(found);
      }
      // slick slider code
      $(".slider-images").slick({
        dots: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: !0,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }, 200);
  });

  // dev_slider:-
  $(".slider-block").slick({
    lazyLoad: "onDemand",
    centerMode: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,

    responsive: [
      {
        breakpoint: 1440,
        settings: {
          arrows: true,
          slidesToShow: 3,
          centerMode: false /* set centerMode to false to show complete slide instead of 3 */,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 2,
          centerMode: false /* set centerMode to false to show complete slide instead of 3 */,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 3,
          centerMode: false /* set centerMode to false to show complete slide instead of 3 */,

          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 2,
          centerMode: false /* set centerMode to false to show complete slide instead of 3 */,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 567,
        settings: {
          arrows: true,
          slidesToShow: 1,
          centerMode: false /* set centerMode to false to show complete slide instead of 3 */,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".alert").show();

  $(".closebtn").click(function () {
    // alert("testr");
    $(".modal-wrapper").hide();
  });

  $("body").addClass("intro");
  $(".closebtn").click(function () {
    // alert("test");
    $("body").removeClass("intro");
  });

  $(document).ready(function () {
    $(".searchform .close").click(function () {
      $(".searchform").hide();
      $(".cstm-search-btn").show();
    });
  });

  $(".cstm-search-btn").on("click", function () {
    $(".searchform").show();
    $(this).hide();
  });
  ////////////quantity code backup
  $(".product-variant-all-image a.variation-option").click(function () {
    console.log("xxx");
    // $('.product-variant-all').val('value').trigger('change');
    if (
      jQuery(".product-variant-all-image a.variation-option").hasClass("active")
    ) {
      jQuery(".product-variant-all-image a.variation-option").removeClass(
        "active"
      );
      jQuery(this).addClass("active");
    } else {
      console.log("hdhdh");
      jQuery(this).addClass("active");
    }
    // var select=$(this).find(':selected').val();
    // console.log('select',select);
    // $('#dynamicChange').val('1').trigger('change');
    var price = $(this).data("price");
    $(this).parents(".product-details").find(".variant-price").text(price);
    jQuery(this)
      .parents(".product-details")
      .find(".product-select_pr.product-form__variants")
      .val($(this).data("value"));
  });




  
  // $(".quantity-dropdownbox").change(function () {
  //   var quantity = $(this).val();
  //   $(this).parents(".product-price-btn-atc").find(".input-text").val(quantity);
  // });
      $(".quantity-dropdownbox").change(function () {
    var quantity = $(this).val();
    $(this).closest(".prd_parent").find(".gray_form").find("input.input-text.qty").val(quantity);
  });

  ////quantity coe backup end

  $("#nt-mobile-menu .custom_mobile_menu ul li a").on("click", function () {
    $(this).siblings(".nav_dropdown").slideToggle();
  });

  //js for menu//
  if ($(window).width() < 768) {
    console.log("Less than 767");

    $(function () {
      $(".for-mobile-menu").click(function (e) {
        e.preventDefault();
        test();
      });
    });
  } else {
    console.log("More than 767");
  }
  //end js for menu//

  //for hide the packs count start //
  // $(document).ready(function () {
  //   $("li[data-index]").on("click", function () {
  //     console.log("testrrrryyyyy");
  //     var selectedValue = $(this).data("value");
  //     console.log("selectedValue", selectedValue);
  //     var selectedPrice = $(
  //       '.price-wraps span.price[custom-variant-id="' + selectedValue + '"]'
  //     );
  //     console.log("selectedPrice", selectedValue);
  //     var variantPrice = $(this).find(".variant-price").text();
  //     console.log("variantPrice", variantPrice);

  //     // selectedPrice.find('ins').append(variantPrice);
  //     // $(".nt_name_currents").append(selectedValue);
  //     text = selectedValue.replace("5 Rs. 9,300.05 Rs. 1,860.01 / count");
  //     $(".nt_name_current").text(text);
  //     // $(".nt_name_currents").replaceWith(selectedValue);
  //   });
  // });
  //for hide the packs count end //
  // $(".swatch__value").on("change", function () {
  // $(".variant_name").click(function () {
  //   console.log(this);
  // });
});

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
$(document).ready(function () {
  $("li[data-index]").on("click", function () {
    console.log("testrrrryyyyy");
    var selectedValue = $(this).data("value");
    console.log("selectedValue", selectedValue);
    var selectedPrice = $(
      '.price-wraps span.price[custom-variant-id="' + selectedValue + '"]'
    );
    console.log("selectedPrice", selectedValue);
    jQuery("h5.swatch__title span.nt_name_currents").text(selectedValue);
    var variantPrice = $(this).find(".variant-price").text();
    console.log("variantPrice", variantPrice);

    text = variantPrice.replace("RS. 7,621.63");
    $(".custom-ins").text(text);

        var textone = variantPrice.replace("variantPrice");
    console.log("textone","-"+ textone)
  
    $(".wholesale-packs-add-to-cart").text(" - " + textone);
  
    setTimeout(function(){
        var varinat_id = getParameterByName("variant");
    console.log("varinat_id", varinat_id);
      jQuery("select.product-select_pr.product-form__variants.select1.hide.hidden")
    .val(varinat_id)
    .trigger("change");
},500)
    
  });

  //

  var varinat_id = getParameterByName("variant");

  jQuery("select.product-select_pr.product-form__variants.select1.hide.hidden")
    .val(varinat_id)
    .trigger("change");

  ////////////quantity code backup
$('.product-variant-all-image a.variation-option').click(function(){ 
  console.log("xxx");
    // $('.product-variant-all').val('value').trigger('change');
  if(jQuery(".product-variant-all-image a.variation-option").hasClass('active')){
    jQuery(".product-variant-all-image a.variation-option").removeClass('active');
    jQuery(this).addClass('active');
  }else{
    console.log('hdhdh');
    jQuery(this).addClass('active');
  }
  // var select=$(this).find(':selected').val();
  // console.log('select',select);
 // $('#dynamicChange').val('1').trigger('change');
  var price= $(this).data("price");
  $(this).parents(".product-details").find(".product-price").text(price);
  jQuery(this).parents(".product-details").find(".product-select_pr.product-form__variants").val($(this).data("value"));
});

//   $(".quantity-dropdownbox").change(function(){
// var quantity= $(this).val();
//    $(this).parents(".product-price-btn-atc").find(".input-text").val(quantity);
// });
      $(".quantity-dropdownbox").change(function () {
    var quantity = $(this).val();
    $(this).closest(".prd_parent").find(".gray_form").find("input.input-text.qty").val(quantity);
  });
  ////quantity code backup end
});

$(document).ready(function(){
  var checkInput = (e) => {
  const content = $("#RecoverEmail").val().trim();
  $('#my-button').prop('disabled', content === '');
};


$(document).on('keyup', '#RecoverEmail', checkInput);
});

$(document).ready(function(){
  var checkInput = (e) => {
  const content = $("#RecoverEmailSide").val().trim();
  $('#my_button_sidebar').prop('disabled', content === '');
};


$(document).on('keyup', '#RecoverEmailSide', checkInput);
})

$(document).ready(function(){
$(".close_an_bar").click(function(){
  $(".announcement_bar").hide();
});
});


  //may 16 start
  $(document).ready(function(){
 // Reset variant and quantity after adding to cart
 jQuery(document).on("click", ".add_to_cart_button", function () {
    // Wait briefly to ensure the cart logic completes
    setTimeout(function () {
      // Reset dropdown and hidden input to 1
      $(".quantity-dropdownbox").val("1");
      $("input.input-text.qty").val("1");

      // Reset variant to first one
      $(".product-variant-all-image a.variation-option").removeClass("active");
      $(".product-variant-all-image a.variation-option:first").addClass("active");

      // Reset the price to the first variant's price
      var firstVariantPrice = $(".product-variant-all-image a.variation-option:first").data("price");
      $(".variant-price").text(firstVariantPrice);

      // Reset the selected variant value to the first variant's ID
      var firstVariantValue = $(".product-variant-all-image a.variation-option:first").data("value");
      $(".product-select_pr.product-form__variants").val(firstVariantValue);
    }, 500); // Adjust timing if needed
  });
})
  // may 16 end  


jQuery(document).ready(function () {
  if (jQuery('body').hasClass('template-search')) {
    jQuery('li.grid-item').has('.article-card-wrapper').hide();
  }
});

// 8April2026
// end

// 1MAY2026
// jQuery(document).ready(function ($) {

//     // move Add to Cart after quantity section
//     jQuery('.product-form__buttons').insertAfter('.product-form-quantity');

// });

jQuery(document).ready(function($){

  var quantityBlock = $('.aa.block.buy_buttons-custm');
  var addToCartBlock = $('.aa.block.custom_buy_button_PkHDDz-custm');

  if (quantityBlock.length && addToCartBlock.length) {

    // wrap both together
    quantityBlock.add(addToCartBlock)
      .wrapAll('<div class="quantity-addtocart-wrapper"></div>');

  }

});

// END

// 4/04/2026/start
jQuery(document).ready(function($){

  var quantityBlock = $('.aa.block.buy_buttons-custm');
  var addToCartBlock = $('.aa.block.custom_buy_button_PkHDDz-custm');
  var subscriptionWidget = $('.recharge-subscription-widget').closest('.aa.block');

  if (quantityBlock.length && addToCartBlock.length && subscriptionWidget.length) {

    // Step 1: wrap
    var wrapper = quantityBlock.add(addToCartBlock)
      .wrapAll('<div class="quantity-addtocart-wrapper"></div>')
      .parent();

    // Step 2: move AFTER subscription widget
    subscriptionWidget.after(wrapper);

  }

});


jQuery(document).ready(function($){

  // run only on product detail page (PDP)
  if ($('.product-section').length > 0) {

    $('.quick-add__submit.tooltip-btn.button.button--full-width').each(function(){

      var tooltipText = $(this).find('.tooltip-text').text().trim();

      // only for Quick View
      if (tooltipText === 'Quick View') {

        $(this)
          .closest('.card-wrapper.product-card-wrapper')
          .addClass('quickview-addtocart');

      }

    });

  }

});



// END

// 5/05/26
jQuery(function () {

  // wait a bit to ensure Shopify sections loaded
  setTimeout(function () {

    if (window.isWholesaleProduct === true || window.isWholesaleProduct === "true") {

      var rightColumn = jQuery('.column-right');
      var wholesaleForm = jQuery('.nm-easywholesale-form');
      var buyButtons = jQuery('.buy_buttons-custm');

      if (!rightColumn.length) return;

      rightColumn.empty();

      if (wholesaleForm.length) {
        rightColumn.append(wholesaleForm);
      }

      if (buyButtons.length) {
        rightColumn.append(buyButtons);
      }

      jQuery('.section-text_1-margin.product-text.small').remove();
      jQuery('.aa.block.buy_buttons-custm').remove();
       jQuery('.aa.block.complementary-custm').remove();

    }

  }, 300);

});
// end

// 8May2026
jQuery(document).ready(function($) {
  $('.grid-item').each(function() {
    if ($(this).find('h3').text().trim() === 'Bundle') {
      $(this).find('a').attr(
        'href',
        'https://baselaboratories.com/collections/bundles'
      );
    }
  });
});

// end
// 20/05/26 start

﻿
// jQuery(document).ready(function () {

//     var hasIngredients = jQuery('.ingredient-details-content').length > 0;

//     // =========================
//     // CASE: NO INGREDIENTS
//     // =========================
//     if (!hasIngredients) {

//         let usageAdded = false;

//         jQuery('.product-accordion').each(function () {

//             var $tab = jQuery(this);
//             var text = $tab.find('summary .accordion__title').text().toLowerCase();

//             text = text.replace(/\s+/g, ' ').trim();

//             // BENEFITS + INGREDIENTS → convert to USAGE
//             if (
//                 text.includes('benefits') 
                
//             )
//             else(
//               text_1.includes('ingredients')

//             )
//              {

//                 // duplicate usage remove
//                 if (usageAdded) {
//                     $tab.remove();
//                     return;
//                 }

//                 // title change
//                 $tab.find('summary .accordion__title').text('Usage');
//                 $tab.find('summary .accordion__title').text_1('Material');

//                 // heart icon remove
//                 $tab.find('.icon-accordion').remove();

//                 // optional
//                 $tab.find('.collapsible__content').hide();

//                 $tab.addClass('converted-usage');

//                 usageAdded = true;
//             }

//         });

//     }

//     // =========================
//     // CASE: INGREDIENTS EXISTS
//     // =========================
//     else {

//         jQuery('.product-accordion').show();

//     }

// });
// end

// 2june 2026

jQuery(document).ready(function () {

  $('.mobile-product-description-toggle').on('click', function () {

    var $accordion = $(this).closest('.mobile-product-description-accordion');
    var $icon = $(this).find('.mobile-product-description-icon');

    $accordion.toggleClass('active');

    if ($accordion.hasClass('active')) {
      $icon.text('−');
      $(this).attr('aria-expanded', 'true');
    } else {
      $icon.text('+');
      $(this).attr('aria-expanded', 'false');
    }

  });

});
// end

// 19/06/2026 start
jQuery(document).ready(function ($) {

    function closeDrawer() {

    $('.mobile-inline-details[open]').prop('open', false);

    const $drawer = $('#Details-menu-drawer-container');

    $drawer.removeClass('menu-opening');
    $('#menu-drawer').removeClass('menu-opening active');

    // Fade out shadow smoothly
    $('#menu-drawer').addClass('closing');

    setTimeout(function () {
        $drawer.prop('open', false);

        $drawer.find('summary')
            .attr('aria-expanded', 'false');

        $('#menu-drawer').removeClass('animate closing');

        $('body, html').removeClass(
            'overflow-hidden overflow-hidden-mobile overflow-hidden-tablet'
        );
    }, 1000);
}

    // Close button click
    $('.menu-drawer-close').on('click', function (e) {
        e.preventDefault();
        closeDrawer();
    });

    // Click outside drawer
    $(document).on('click', function (e) {

        if (
            $('#Details-menu-drawer-container').prop('open') &&
            !$(e.target).closest('#menu-drawer').length &&
            !$(e.target).closest('summary.header__icon--menu').length
        ) {
            closeDrawer();
        }
    });

});

jQuery(document).ready(function ($) {

    var $wholesaleMenu = $('#Details-menu-drawer-inline-4 .mobile-inline-submenu');

    // First item -> Shop
    $wholesaleMenu.find('li:eq(0) a')
        .attr('href', '/collections/piercing-aftercare-wholesale')
        .find('span')
        .text('Shop');

    // Second item -> Apply to Wholesale
    $wholesaleMenu.find('li:eq(1) a')
        .attr('href', '/pages/apply-for-wholesale')
        .find('span')
        .text('Apply to Wholesale');

    // Hide remaining items
    $wholesaleMenu.find('li:gt(1)').hide();

});
// end


jQuery(function ($) {
  function moveSecurePayment() {
    // dynamic secure payment section id
    var $secure = $('[id^="shopify-section-"][id*="__secure_payment_icons_"]').first();
    // target location
    var $target = $('.product-info-container .column-right').first();
    if (!$secure.length || !$target.length) return;
    if ($secure.data('moved')) return; // prevent repeat move
    $target.append($secure);
    $secure.data('moved', true);
  }
  // run multiple times because apps load late
  moveSecurePayment();
  setTimeout(moveSecurePayment, 500);
  setTimeout(moveSecurePayment, 1200);
  setTimeout(moveSecurePayment, 2200);
  // observer backup
  var observer = new MutationObserver(function () {
    moveSecurePayment();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// 09/09/2026 start 

jQuery(document).ready(function () {

  var currentPath = window.location.pathname;

  if (
    currentPath === '/collections/piercing-aftercare-wholesale' ||
    currentPath === '/collections/speciality-skin-care-wholesale'
  ) {
    jQuery('.product-grid-section.section-template--22139649261827__product-grid-padding').hide();
  }

});

jQuery(document).ready(function () {
  jQuery('a[href="https://baselaboratories.com/pages/apply-for-wholesale"]')
    .addClass('wholesale-account-button');
});
// end

// 23/09/2026 start
jQuery(document).ready(function ($) {
  $('#MegaMenu-Content-4 .wholesale-account-button')
    .closest('li')
    .addClass('wholesale-menu-account');
});
// end